import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useProject } from "../../hooks/useProject";
import ProjectHeader from "../../components/common/ProjectHeader/ProjectHeader";
import ProjectNavbar from "../../components/common/ProjectNavbar/ProjectNavbar";
import StatsRow from "../../components/projectDetails/statsRow/StatsRow";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { getStreak } from "../../functions/getStreak";

import '../../styles/ProjectDetails.css';

export default function ProjectDetails(){
  //Podstawowe ustawienia
    
    const{index, project} = useProject();
    const navigate = useNavigate();
    const today = new Date().toISOString().split("T")[0];
  //Rozdziały i cel dzienny
    const todayEntry = project.history.find(entry => entry.date === today);
    const TodayWords = todayEntry ? todayEntry.words : 0;
    const Streak = getStreak(project.history);
  
    if(!project) return ( <div> 
          <h2> Projekt nie istnieje </h2>
          <button onClick={() => navigate('/')}>Wróć do listy</button> </div> );


    return (
      <div className="project-wrapper">
        <ProjectHeader
        path={'/local'}
        headerTitle={project.title}
        showBackButton={true}
        />
            
            <div className="project-card">
                <img src = {project.cover} className="project-img"/>
                <progress value={project.actualwords}  max={project.words}> </progress> <br/>
                <h5> {project.actualwords}/{project.words}</h5>
                <h6>{project.description}</h6>
                  <StatsRow
                    goalEnabled={project.settings.goalEnabled}
                    todayWords={TodayWords}
                    dailyGoal = {project.settings.dailyGoal}
                    streak={Streak}/>
                  
            </div>
            
      <ProjectNavbar projectIndex={index}/>
    </div>)
}